export default __webpack_public_path__ + "static/media/cars-img.5ab6a95b.svg";